import { instance } from '~/utils/api/api';
import { Dayjs } from 'dayjs';
import i18n from '~/i18n';

export async function downloadReportFoodFile(
  reportPath: string,
  startDate: Dayjs | null,
  endDate: Dayjs | null,
  isAllAccommodations?: boolean,
  extraParams?: Record<string, unknown>
) {
  await instance.get(`admin/${reportPath}`, {
    params: {
      locale: i18n.language,
      ...(reportPath.includes('food-wares-export') ||
      reportPath.includes('food-wares-all-export') ||
      reportPath.includes('food-orders-export') ||
      reportPath.includes('food-order-cashier') ||
      reportPath.includes('food-technologist-export')
        ? {
            dates: [
              startDate
                ?.hour(0)
                .minute(0)
                .second(1)
                .format('YYYY-MM-DD HH:mm:ss'),
              endDate?.endOf('day').format('YYYY-MM-DD HH:mm:ss'),
            ],
          }
        : {
            start_date: startDate
              ?.hour(0)
              .minute(0)
              .second(1)
              .format('YYYY-MM-DD HH:mm:ss'),
            end_date: endDate?.endOf('day').format('YYYY-MM-DD HH:mm:ss'),
          }),
      ...(isAllAccommodations ? { accommodation_all: 1 } : {}),
      ...extraParams,
    },
    responseType: 'blob',
  });
}
